module.exports = __webpack_public_path__ + "img/appIcon-ui--invoicesSheet.42ca9cee.svg";